import React from "react";

const dailyTimeline = [
  { label: "Breakfast", highlight: false },
  { label: "Activities", highlight: true },
  { label: "Meals", highlight: false },
  { label: "Relaxation", highlight: true },
  { label: "Dinner", highlight: false },
];

const DailyLife = () => {
  return (
    <section className="py-10 px-10 font-poppins mb-[100px]">
      <div className="max-w-screen-xl mx-auto text-center">
        <h2 className="text-green text-[24px] lg:text-[32px] xl:text-[36px] font-semibold mb-2 sm:mb-[30px] uppercase">
          DAILY LIFE AT{" "}
          <span className="text-[var(--primary-orange-color)]">ROSELEA</span>
        </h2>
        <p className="text-[12px] lg:text-[18px] xl:text-[20px] text-[var(--light-gray-color)] font-light leading-relaxed">
          Our days are structured around meaningful engagement, routine, and
          support. Each day includes a balanced mix of activities to encourage
          growth, wellness, and connection.
        </p>

        {/* Arrow Line with Milestones - Vertical on small screens, Horizontal on large screens */}
        <div className="relative mt-16 pt-0 lg:pt-10">
          {/* Vertical Layout for screens < 1024px */}
          <div className="lg:hidden flex justify-center h-[600px]">
            <div className="relative">
              {/* Vertical Line with Arrow at bottom */}
              <div className="absolute left-2/3 transform -translate-x-1/2 w-[13px] bg-green h-full"></div>

              {/* Milestones */}
              <div className="flex flex-col space-y-20 mt-8">
                {dailyTimeline.map((item, idx) => (
                  <div key={item.label} className="relative flex items-center">
                    {/* Left side label */}
                    <div className="w-32 text-right pr-8">
                      <span
                        className={`text-base font-semibold ${
                          item.highlight ? "text-[#FF9487]" : "text-green"
                        }`}
                      >
                        {item.label}
                      </span>
                    </div>

                    {/* Center circle */}
                    <div className="relative z-10 w-[33px] h-[33px] bg-green rounded-full flex items-center justify-center shadow-md">
                      <div className="w-4 h-4 bg-[#FF9487] rounded-full" />
                    </div>

                    {/* Right side spacer */}
                    <div className="w-14"></div>
                  </div>
                ))}
              </div>

              {/* Arrow at the bottom of the line */}
              <div className="absolute bottom-0 left-2/3 transform -translate-x-1/2 translate-y-full">
                <div className="w-0 h-0 border-l-[16px] border-r-[16px] border-t-[16px] border-l-transparent border-r-transparent border-t-green"></div>
              </div>
            </div>
          </div>

          {/* Horizontal Layout for screens >= 1024px */}
          <div className="hidden lg:block">
            {/* Horizontal Line with Arrow */}
            <div className="relative h-6 bg-green w-full right-3"></div>

            <div className="absolute right-0 top-1/2 -translate-y-[53px] translate-x-1 w-0 h-14 border-t-[26px] border-b-[26px] border-l-[36px] border-t-transparent border-b-transparent border-l-green " />

            {/* Milestones */}
            <div className="flex justify-between items-center w-5/6 ml-12 relative -translate-y-11">
              {dailyTimeline.map((item, idx) => (
                <div key={item.label} className="flex flex-col items-center">
                  {/* Green Circle */}
                  <div className="w-[60px] h-[60px] bg-green rounded-full flex items-center justify-center mb-2 shadow-md ">
                    {/* Red Dot */}
                    <div className="w-4 h-4 bg-[#FF9487] rounded-full" />
                  </div>
                  {/* Label */}
                  <span
                    className={`text-base font-semibold ${
                      item.highlight ? "text-[#FF9487]" : "text-green"
                    }`}
                  >
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DailyLife;
